import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  container: {
    width: '918px'
  },
  loader: {
    justifyContent: 'center',
    display: 'flex',
    paddingTop: '24px'
  },
  imageContainer: {
    margin: '30px auto',
    padding: '0 30px',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, 284px)',
    justifyContent: 'space-between'
  },
  image: {
    width: '284px',
    height: '148px',
    float: 'left',
    marginBottom: '31px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover'
  }
}));
